import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { isAppPath } from "../lib/app-nav";

type Props = {
  children?: ReactNode;
  to?: string;
  href?: string;
  target?: string;
  slot?: string;
  commandFor?: string;
  command?: string;
  rel?: string;
  onClick?: () => void;
};

/** Polaris `s-link` with SPA-safe internal navigation. */
export function AppLink({
  children,
  to,
  href,
  target,
  slot,
  commandFor,
  command,
  rel,
  onClick,
}: Props) {
  const navigate = useNavigate();
  const raw = to || href;
  const internal = raw && isAppPath(raw) ? raw : null;
  const external =
    !internal && raw && !isAppPath(raw)
      ? raw
      : !internal
        ? href
        : undefined;
  /** Leave the app → new tab. */
  const externalTarget = external ? target || "_blank" : undefined;

  return (
    <s-link
      slot={slot}
      commandFor={commandFor}
      command={command}
      rel={external ? rel || "noopener noreferrer" : rel}
      href={internal || external}
      target={externalTarget}
      onClick={() => {
        onClick?.();
        if (internal) navigate(internal);
      }}
    >
      {children}
    </s-link>
  );
}
